module.exports = __webpack_public_path__ + "static/media/schedule.01560e07.svg";